const distanceRange = [5, 10, 50, 100]
const tricogLogo = 'https://tricog.in/wp-content/uploads/2022/05/Asset-1.svg'
const CONFIG = {
  google_map_api: process.env.REACT_APP_GOOGLE_MAP_API,
  api_url: process.env.REACT_APP_API_URL,
  distanceRange,
  tricog_logo: tricogLogo,
  mobile_number: process.env.REACT_APP_FMT_MOBILE_NUMBER
}

export default CONFIG
